<template>
  <v-layout row wrap>
    <v-flex xs12>
      <connection-manager ref="connectionManager" v-model="connecting" />
    </v-flex>
    <v-flex xs4>
      <v-menu
        v-model="fromDateDialog"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="form.from"
            label="From"
            hint="Start Date"
            persistent-hint
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.from"
          no-title
          @input="fromDateDialog = false"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs4>
      <v-menu
        v-model="toDateDialog"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="form.to"
            label="To"
            hint="End Date"
            persistent-hint
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.to"
          no-title
          @input="toDateDialog = false"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs4>
      <v-btn @click.native="sendReports()" :disabled="connecting"
        >Send Reports</v-btn
      >
    </v-flex>
  </v-layout>
</template>

<script>
import ConnectionManager from './ConnectionManager'
export default {
  components: {
    ConnectionManager
  },
  data() {
    return {
      connecting: false,
      filter: null,
      form: {
        from: ''
      },
      fromDateDialog: false,
      toDateDialog: false
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if (to.params.filter !== this.filter) {
        this.filter = to.params.filter
      }
    }
  },
  methods: {
    sendReports() {
      let that = this
      this.$refs.connectionManager.post(
        'sendReportsForAllClients',
        {
          onSuccess(response) {
            that.form = {}
          }
        },
        that.form
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientsDeliveriesReport.vue